import Vue from 'vue';
import Vuex from 'vuex';
import Login from '@/store/Login';
import Comun from '@/store/Comun';
import Forseti from '@/store/Forseti';
import PJ from '@/store/PJ';
import Cuentas from '@/store/Cuentas';
import Micrositios from '@/store/Micrositios';
import PaginaOficial from '@/store/PaginaOficial';
import SISEVA from '@/store/SISEVA';
import SIAP from '@/store/SIAP';
import SICCIJ from '@/store/SICCIJ';
import TemisCivil from '@/store/TemisCivil';
import Archivo from '@/store/ArchivoJudicial';
import SICPO from '@/store/SICPO'
import SINOJ from '@/store/SINOJ'
import SICUS from '@/store/SICUS'
import SIPSIC from '@/store/SIPSIC'
import SICSEN from '@/store/SICSEN'
import SIQA from '@/store/SIQA'
import SIFA from '@/store/SIFA'
import SIVAC from '@/store/SIVAC'

Vue.use(Vuex);

let state = {};
let getters = {};
let mutations = {};
let actions = {};

crearStore(Login);
crearStore(Comun);
crearStore(Forseti);
crearStore(PJ);
crearStore(Cuentas);
crearStore(Micrositios);
crearStore(PaginaOficial);
crearStore(SISEVA);
crearStore(SIAP);
crearStore(SICCIJ);
crearStore(TemisCivil);
crearStore(Archivo);
crearStore(SICPO);
crearStore(SINOJ);
crearStore(SICUS);
crearStore(SIPSIC);
crearStore(SICSEN)
crearStore(SIQA);
crearStore(SIFA);
crearStore(SIVAC);

function crearStore(datosStore) {  
  state = Object.assign(state, datosStore.State);
  getters = Object.assign(getters, datosStore.Getters);
  mutations = Object.assign(mutations, datosStore.Mutations);
  actions = Object.assign(mutations, datosStore.Actions);
}

export const store = new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

const library = new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

export default library;



// WEBPACK FOOTER //
// ./src/store/index.js